module.exports = __webpack_public_path__ + "img/cloth_g3_shoe-03.48e6fa05.svg";